import { gql } from 'react-apollo';

export const annotationDataQuery = gql`
  query getLearnosityAssignmentAnnotations($assignmentId: Int!) {
    learnosityAssignmentAnnotations(assignmentId: $assignmentId) {
      id
      annotation
      highlight {
        id
        item
        path
        offset
        selection
        color
      }
    }
  }
`;

export const createAnnotationMutation = gql`
  mutation createLearnosityAnnotation(
    $assignmentId: Int!
    $annotation: String!
    $highlight: HighlightInput!
  ) {
    createLearnosityAnnotation(
      assignmentId: $assignmentId
      annotation: $annotation
      highlight: $highlight
    ) {
      ok
    }
  }
`;

export const updateAnnotationMutation = gql`
  mutation updateLearnosityAnnotation(
    $learnosityAnnotationId: Int!
    $annotation: String!
  ) {
    updateLearnosityAnnotation(
      annotationId: $learnosityAnnotationId
      annotation: $annotation
    ) {
      ok
    }
  }
`;

export const deleteAnnotationMutation = gql`
  mutation deleteLearnosityAnnotation($learnosityAnnotationId: Int!) {
    deleteLearnosityAnnotation(annotationId: $learnosityAnnotationId) {
      ok
    }
  }
`;
